import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface ISelectProjectStyles {
  root: IStyle;
  description: IStyle;
  buttons: IStyle;
}

export interface ISelectProjectClassNames {
  root: string;
  description: string;
  buttons: string;
}

export const selectProjectStylesDefault = (_theme: IH2OTheme): Partial<ISelectProjectStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    paddingTop: 24,
  },
  description: {
    marginTop: 8,
  },
  buttons: { textAlign: 'right', paddingTop: 24 },
});
